import { TAppointment, TListOfValue } from "@mzara/graphql";
import { atomFamily } from "recoil";


export const KanbanCards = atomFamily<Array<TAppointment>, string>({
    key: 'state.KanbanCards',
    default : undefined,
});

